$ = require 'jquery'
{ track, trackUe } = require '@trello/analytics'
{ Analytics } = require '@trello/atlassian-analytics'
IdCache = require 'app/scripts/db/id-cache'
Card = require 'app/scripts/models/card'
Payloads = require 'app/scripts/network/payloads'
Util = require 'app/scripts/lib/util'
PopOver = require 'app/scripts/views/lib/pop-over'
AddListPopoverView = require 'app/scripts/views/board/add-list-popover-view'
{ canAddCard } = require 'app/scripts/views/card/card-limits-error'

module.exports.openCardComposerInFirstList = ->
  firstList = @model.listList.first()
  @model.composer.save({
    list: firstList
    index: firstList.openCards().length
    vis: true
  })
  trackUe('card composer', 'open', '', '', '', 'via navigating to board', { 'boardid': @model.get('id') })
  if @sendGASEvent
    Analytics.sendUIEvent
      action: 'opened'
      actionSubject: 'cardComposer'
      source: 'boardScreen'
      attributes:
        method: 'firstList'

  return

module.exports.scrollToCard = (card) ->
  list = card.getList()
  @scrollToList(list)
  @viewForList(list).scrollToCard(card)

module.exports.preventScrollSelection = ->
  # So here's the deal.
  #
  # When you're selecting cards with the keyboard, we'll scroll the
  # board and the lists on it to ensure the currently selected card
  # is always visible.
  #
  # As a result of this scrolling, it's possible that the mouseenter event
  # will fire on a CardView -- which, if you look above at the handling of
  # mouseEnterCardView, will cause us to mark the newly hovered card as
  # selected, even though you didn't actually move the mouse at all.
  #
  # So we remember that we've just selected something with the keyboard,
  # and we should ignore mouse events until the next time the user moves
  # the mouse.
  #
  # But.
  #
  # Chrome will fire mousemove events even when the mouse *hasn't* moved,
  # as a result of the scroll.
  #
  # https://code.google.com/p/chromium/issues/detail?id=241476
  #
  # So we can't just wait for the next mousemove event -- we have to wait
  # for the next mousemove event that has occurred as the result of the
  # user moving the mouse.
  #
  # Detecting that is a bit of a hack, but appears to work well enough for
  # now.
  #
  # IE 10 will apparently just fire mousemove events constantly, even
  # when a scroll doesn't occur. I don't know how to fix that. I can't find
  # a good workaround for IE 10. So that's just not gonna work.

  if @ignoreMouseCardSelects
    return

  isResultOfActualPhysicalMouseMovement = (e) ->
    { movementX: x, movementY: y } = e.originalEvent
    x != 0 || y != 0

  @ignoreMouseCardSelects = true

  bindOnce = =>
    $(document).one 'mousemove', (e) =>
      if isResultOfActualPhysicalMouseMovement(e)
        @ignoreMouseCardSelects = false
      else
        bindOnce()
      return

  bindOnce()
  return

module.exports.moveCard = (direction) ->
  @preventScrollSelection()

  selectedCard = @model.viewState.getCard()

  if !selectedCard?
    # Select the first card in the first list that has a card
    listWithCards =
      @model.listList.find (list) -> !list.openCards().isEmpty()
    listWithCards?.selectFirstCardInList()
    return

  selectedList = selectedCard.getList()

  openCards = selectedList.openCards()
  cardIndex = openCards.indexOf(selectedCard)

  findNextGoodIndex = (currentIndex, indexDelta, upperBound, fxIndexIsGood) =>
    newIndex = currentIndex + indexDelta
    if @model.filter.isFiltering
      while 0 <= newIndex < upperBound && !fxIndexIsGood(newIndex)
        newIndex += indexDelta
    # We just return something out of bounds if there's no index that works
    return newIndex

  if direction in ['up', 'down']
    indexDelta = if direction == 'up' then -1 else 1
    newCardIndex = findNextGoodIndex cardIndex, indexDelta, openCards.length, (newCardIndex) =>
      @model.filter.satisfiesFilter(openCards.at(newCardIndex))

    if 0 <= newCardIndex < openCards.length
      card = openCards.at(newCardIndex)
      @scrollToCard card
      @model.viewState.selectCard card

  else if direction in ['left', 'right']
    openLists = @model.listList
    listIndex = openLists.indexOf(selectedList)

    listIndexDelta = if direction == 'left' then -1 else 1
    newListIndex = findNextGoodIndex listIndex, listIndexDelta, openLists.length, (newListIndex) =>
      openLists.at(newListIndex).openCards().any (card) =>
        @model.filter.satisfiesFilter(card)
    if 0 <= newListIndex < openLists.length
      newList = openLists.at(newListIndex)
      newListOpenCards = newList.openCards()
      newCardIndexStart = Math.min(cardIndex, newListOpenCards.length - 1)
      for delta in [1, -1]
        newCardIndex = findNextGoodIndex newCardIndexStart - delta, delta, newListOpenCards.length, (newCardIndex) =>
          @model.filter.satisfiesFilter(newListOpenCards.at(newCardIndex))
        if 0 <= newCardIndex < newListOpenCards.length
          card = newListOpenCards.at(newCardIndex)
          @model.viewState.selectCard card
          @scrollToCard card
          break

module.exports.dblClickAddListMenu = (e) ->
  Util.stop(e)

  if $(e.target).closest('.js-card-templates-button').length > 0
    return

  if  @model.editable()
    if $(e.target).closest('.js-list-content').length == 0
      if !@model.viewState.get('listComposerOpen')
        # They didn't click inside a list
        track("Board View", "Open Add List Menu via Double Click")
        if @sendGASEvent
          Analytics.sendScreenEvent
            name: 'addListInlineDialog'
            attributes:
              method: 'doubleClick'

        PopOver.show
          clientx: e.clientX
          clienty: e.clientY
          view: new AddListPopoverView
            model: @model
            modelCache: @modelCache
            didAddList: (list) => @scrollToList(list)
    else if (list = @model.viewState.getList())?
      $elClicked = @$(document.elementFromPoint(e.clientX, e.clientY))

      if($elClicked.closest('.list-header-name,.card-composer,.list-card').length == 0)
        $card = @$(document.elementFromPoint(e.clientX, e.clientY - 16)).closest('.list-card')

        track("Board View", "Open Card Composer via Double Click")
        if @sendGASEvent
          Analytics.sendUIEvent
            action: 'opened'
            actionSubject: 'cardComposer'
            source: 'boardScreen'
            attributes:
              method: 'doubleClick'

        @model.composer.save({
          list: list
          index:
            if $card.length
              # Put the composer one spot after the card above where we double clicked
              Math.max($card.closest('.js-list-cards').find('>.list-card').index($card), 0) + 1
            else
              # Put the composer at the top
              0
          vis: true
        })


  return

# Returns the idList/index to move a card to.  It prefers to move the card
# above the card that is 'active', and will fall back to inserting the card
# at the bottom of idListDefault if no card is active
module.exports._insertCardPosition = (idListDefault) ->
  activeCard = @model.viewState.getCard()
  if activeCard?
    idList: activeCard.get('idList')
    index: activeCard.getIndexInList()
  else
    idList: idListDefault
    index: @model.listList.get(idListDefault).cardList.length

module.exports.moveCardRequested = (listView, { shortLink, idList }) ->
  { idList, index } = @_insertCardPosition(idList)
  idCard = IdCache.getId('Card', shortLink) ? shortLink

  Card.load(idCard, Payloads.cardMinimal, @modelCache)
  .then (card) =>
    list = @model.listList.get(idList)
    if card.get('idList') == idList || canAddCard({ destinationList: list })
      card.moveToList(list, index)
  .done()

module.exports.copyCardRequested = (listView, { shortLink, idList }) ->
  { idList, index } = @_insertCardPosition(idList)
  idCard = IdCache.getId('Card', shortLink) ? shortLink

  Card.load(idCard, Payloads.cardMinimal, @modelCache)
  .then (card) =>
    list = @model.listList.get(idList)

    options = {
      hasChecklists: card.checklistList.length > 0,
      hasAttachments: card.attachmentList.length > 0,
      destinationBoard: @model,
      destinationList: list
    }
    if canAddCard(options)
      card.copyTo
        idList: idList
        pos: @model.listList.get(idList).calcPos(index, card)
  .done()
